import React, { Component } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import getCampaignColumn from './SupplierCampaignStatusGridConfig';

const SupplierCampaignStatusSummary = ({ data }) => {
  let datafields = data;
  const headerValue = datafields[0].campaign_name
    ? `Campaign Details (${datafields[0].campaign_name})`
    : 'Campaign Details';
  return (
    <div>
      {data.length > 0 && (
        <BootstrapTable
          keyField="campaign_id"
          columns={getCampaignColumn()}
          data={datafields}
          exportCsv={false}
          search={false}
          pagination={false}
          headerValue={headerValue}
          backgroundColor="#c7c7c7c9"
        />
      )}
    </div>
  );
}

export default SupplierCampaignStatusSummary;
